const Trending = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.5 6.75122H21.7521V12.0034" fill="#F2F2F2" />
    <path
      d="M16.5 6.75122H21.7521V12.0034"
      stroke="#F2F2F2"
      strokeWidth="1.00189"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.24951 17.2505L7.93873 11.5613C8.07802 11.4219 8.2434 11.3114 8.42541 11.236C8.60742 11.1606 8.8025 11.1218 8.99951 11.1218C9.19653 11.1218 9.39161 11.1606 9.57362 11.236C9.75563 11.3114 9.921 11.4219 10.0603 11.5613L12.4387 13.9397C12.578 14.079 12.7434 14.1896 12.9254 14.265C13.1074 14.3404 13.3025 14.3792 13.4995 14.3792C13.6965 14.3792 13.8916 14.3404 14.0736 14.265C14.2556 14.1896 14.421 14.079 14.5603 13.9397L20.9995 7.50049"
      stroke="#F2F2F2"
      strokeWidth="1.00189"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Trending;
